import { BaseFormatter } from "./BaseFormatter";
import { IFormatter } from "./IFormatter";
import { Log } from "./Log";
import { LogLevel } from "./LogLevel";

export class FormatterFull extends BaseFormatter implements IFormatter 
{
    format(log: Log): { pre: string[], messages: string[], post: string[] }
    {
        let pre: string[] = [];
        let messages: string[] = [];
        let post: string[] = [];
        pre.push(this.qoute(this.formatDateTime(log.date), 100, '-'));
        pre.push("Level: " + LogLevel[log.level]);
        messages.push(...this.getMesssages(log.messages));
        post.push(this.qoute("", 100, '-'));
        post.push("");
        return { pre, messages, post };
    }
}